// Membership (yearly/lifetime) validity text + colour for the Fees and Renewal pages.
// Prefers /LoginFees/check_fees_session (session 1 Sep .. 31 Aug); the old
// "feesvalidity" text from /Verification compares calendar years and is wrong
// across sessions, so it is only a fallback.
const formatValidDate = (value) =>
  value
    ? new Date(value).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

const getMembershipValidity = (feesSession, feesDetails, feesValidityText) => {
  if (feesDetails?.feesInfo === "DEFAULTER") {
    return { text: "DEFAULTER", isValid: false };
  }

  switch (feesSession?.resultCode) {
    case "LIFETIME":
      return { text: "LifeTime", isValid: true };
    case "ALREADY_PAID_CURRENT":
      return {
        text: `Valid till ${formatValidDate(feesSession.validTill)}`,
        isValid: true,
      };
    case "PAY_CURRENT":
      return feesSession.validTill
        ? {
            text: `Expired ${formatValidDate(feesSession.validTill)} (${feesSession.currentSession} not paid)`,
            isValid: false,
          }
        : { text: "Not Submitted", isValid: false };
    case "PAY_PREVIOUS":
      return {
        text: `Expired ${formatValidDate(feesSession.validTill)} (${feesSession.previousSession} not paid)`,
        isValid: false,
      };
    default:
      break;
  }

  // Fallback: session check unavailable
  if (feesDetails?.feesStatusCode === 200) {
    return { text: "LifeTime", isValid: true };
  }
  if (feesDetails?.feesStatusCode === 404) {
    return { text: feesDetails?.feesInfo || "Not Submitted", isValid: false };
  }
  const text = (feesValidityText || "Not Submitted").trim();
  return { text, isValid: !/^NOT SUBMITTED/i.test(text) };
};

export default getMembershipValidity;
